import { isAxiosError } from "axios";
import { toast } from "react-toastify";
import { axios } from "../../../utils/axios";
import { toastOptions } from "../../../config/toast";
import { base64ToFileList } from "../../../helpers/base64ToFileList";

const coloresEstados = [
  { id: 1, color: "btn-success" },
  { id: 2, color: "btn-primary" },
  { id: 3, color: "btn-danger" },
];

export const getColorEstado = (id) => {
  let rta = coloresEstados.filter((col) => {
    if (col.id === id) {
      return col.color;
    }
  });
  return rta[0].color;
};

export const getEspecie = async (id, rta, setRta, reset) => {
  setRta({ ...rta, loading: true });
  let response = await axios().get(`especie/${id}`);
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      reset({
        nombre: data.especie.nombre,
        estado: data.especie.estado,
        img_url: data?.img?.file ?? "",
      });
      setRta({ ...rta, loading: false, data: data });
    }
    if (error && !data) {
      setRta({ ...rta, loading: false, error: error });
      toast.error(error, toastOptions);
    }
  } else {
    setRta({ ...rta, loading: false, error: "Hubo un error inesperado" });
  }
};

export const crearEspecie = async (datos, rta, setRta, reset, setImagePreviewUrl) => {
  const formData = new FormData();
  Object.entries(datos)
    .filter(([key, value]) => value !== null && value !== "")
    .forEach(([key, value]) => {
      if (datos[key] instanceof FileList) {
        formData.append(key, datos[key][0]);
      } else {
        if (value instanceof Date) {
          formData.append(key, value.toISOString().split("T")[0]);
        } else {
          formData.append(key, value);
        }
      }
    });
  setRta({ ...rta, loading: true });
  let response = await axios().post("especie", formData);
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setRta({ ...rta, loading: false, data: data });
      toast.success("Especie creada", toastOptions);
      reset();
      setImagePreviewUrl(null);
    }

    if (error && !data) {
      setRta({ ...rta, loading: false, error: error });
      toast.error(error, toastOptions);
    }
  } else {
    setRta({ ...rta, loading: false, error: "Hubo un error inesperado" });
  }
};

export const updateEspecie = async (id, datos, rta, setRta) => {
  if (typeof datos?.img_url == "string") {
    datos.img_url = base64ToFileList(datos?.img_url, `${datos.nombre}.jpg`, "image/jpeg");
  }
  const formData = new FormData();
  Object.entries(datos)
    .filter(([key, value]) => value !== null && value !== "")
    .forEach(([key, value]) => {
      if (datos[key] instanceof FileList) {
        formData.append(key, datos[key][0]);
      } else {
        if (value instanceof Date) {
          formData.append(key, value.toISOString().split("T")[0]);
        } else {
          formData.append(key, value);
        }
      }
    });

  setRta({ ...rta, loading: true });
  let response = await axios().post(`especie/${id}`, formData);
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setRta({ ...rta, loading: false, data: data });
      toast.success("Especie actualizada", toastOptions);
      // setValue("img_url");
      // reset();
      // if (typeof datos?.img_url == "object") {
      //   const reader = new FileReader();
      //   reader.onloadend = () => {
      //     console.log('entre')

      //     setImagePreviewUrl(reader.result);
      //   };
      //   reader.readAsDataURL(watch("img_url")[0]);
      // }
    }

    if (error && !data) {
      setRta({ ...rta, loading: false, error: error });
      toast.error(error, toastOptions);
    }
  } else {
    setRta({ ...rta, loading: false, error: "Hubo un error inesperado" });
  }
};
